<template>
  <div>
    <a-modal
      width="720px"
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="编辑上架eSIM"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
        @submit="handleSubmit"
      >
        <a-form-item label="产品名称">
          <a-input
            v-decorator="['name', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入产品名称' },
                { max: 100, message: '最多100个字符' }
              ]
            }]"
          />
        </a-form-item>

        <a-form-item label="SGP规范">
          <a-checkbox-group
            v-decorator="['sgp_spec_ids', { rules: [{ required: true, message: '请选择SGP规范' }] }]"
            :options="sgpSpecCheckboxOptions"
          />
        </a-form-item>

        <span class="item-title">卡片设置</span>
        <a-row style="margin: 10px 0 10px 9px" :gutter="24">
          <a-col :span="8">卡片材质*</a-col>
          <a-col :span="8">标准价(元)*</a-col>
          <a-col :span="8">底价(元)*</a-col>
        </a-row>

        <a-row
          :gutter="24"
          v-for="(cardType, index) in cardTypes"
          :key="'baseEsimCardTypeEdit-'+ cardType.id"
        >
          <a-col :span="8">
            <a-form-item>
              <a-row style="width: 150px">
                <a-col :span="4">
                  <a-checkbox-group
                    v-decorator="[`base_esim_products_card_types[${index}].card_type_id`]"
                    @change="(checked) => changeCardType(checked, index)"
                  >
                    <a-checkbox :value="cardType.id" />
                  </a-checkbox-group>
                </a-col>
                <a-col :span="20">{{ cardType.name }}</a-col>
              </a-row>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item>
              <a-input-number
                :min="0"
                :max="10000000"
                :step="0.001"
                :precision="3"
                style="width: 120px"
                v-decorator="[`base_esim_products_card_types[${index}].price`, {
                  rules: [
                    { required: cardTypePriceRequired[index], message: '请输入标准价' },
                    { type: 'number', message: '请输入数字' }
                  ]
                }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item>
              <a-input-number
                :min="0"
                :max="10000000"
                :step="0.001"
                :precision="3"
                style="width: 120px"
                v-decorator="[`base_esim_products_card_types[${index}].floor_price`, {
                  rules: [
                    { required: cardTypePriceRequired[index], message: '请输入底价' },
                    { type: 'number', message: '请输入数字' }
                  ]
                }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { findCardTypeOptions } from '@/api/common_options'
import { findCommonTypeOptions } from '@/api/common_type'
import { findBaseEsimProductForm, updateBaseEsimProduct } from '@/api/base_esim_product'

export default {
  name: 'EditBaseEsimProduct',
  props: {
    visible: { type: Boolean, required: true },
    id: { type: Number, required: true }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'base_esim_product_edit' }),
      submitting: false,
      cardTypes: [],
      cardTypePriceRequired: [],
      sgpSpecOptions: [],
      loading: true
    }
  },
  computed: {
    isShow: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    },
    sgpSpecCheckboxOptions() {
      return (this.sgpSpecOptions || []).map((opt) => ({ label: opt.name, value: opt.id }))
    }
  },
  created() {
    Promise.all([
      findCardTypeOptions(),
      findCommonTypeOptions('product_esim_sgp_spec'),
      findBaseEsimProductForm(this.id)
    ]).then(([cardRes, sgpRes, formRes]) => {
      if (cardRes.code === 0) {
        this.cardTypes = cardRes.data
        this.cardTypePriceRequired = this.cardTypes.map(() => false)
      }
      if (sgpRes.code === 0) this.sgpSpecOptions = sgpRes.data
      if (formRes.code === 0) {
        const data = formRes.data
        const fields = {
          name: data.name,
          sgp_spec_ids: data.sgp_spec_ids || []
        }
        const selected = {}
        ;(data.base_esim_products_card_types || []).forEach((ct) => {
          selected[ct.card_type_id] = ct
        })
        this.cardTypes.forEach((cardType, index) => {
          const hit = selected[cardType.id]
          if (hit) {
            this.$set(this.cardTypePriceRequired, index, true)
            fields[`base_esim_products_card_types[${index}].card_type_id`] = [cardType.id]
            fields[`base_esim_products_card_types[${index}].price`] = hit.price
            fields[`base_esim_products_card_types[${index}].floor_price`] = hit.floor_price
          }
        })
        this.$nextTick(() => this.form.setFieldsValue(fields))
      }
      this.loading = false
    })
  },
  methods: {
    changeCardType(checked, index) {
      this.$set(this.cardTypePriceRequired, index, !!(checked && checked.length))
      this.form.validateFields([
        `base_esim_products_card_types[${index}].price`,
        `base_esim_products_card_types[${index}].floor_price`
      ], { force: true })
    },
    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({ title: '请勿重复提交', content: '' })
        return
      }
      this.form.validateFields((err, values) => {
        if (err) return
        const cardTypes = []
        ;(values.base_esim_products_card_types || []).forEach((cardType) => {
          if (cardType && cardType.card_type_id && cardType.card_type_id[0]) {
            cardTypes.push({
              card_type_id: cardType.card_type_id[0],
              price: cardType.price == null ? 0 : Number(cardType.price),
              floor_price: cardType.floor_price == null ? 0 : Number(cardType.floor_price)
            })
          }
        })
        if (!cardTypes.length) {
          this.$warning({ title: '请勾选卡片材质', content: '' })
          return
        }
        this.submitting = true
        updateBaseEsimProduct(this.id, {
          name: values.name,
          sgp_spec_ids: values.sgp_spec_ids || [],
          base_esim_products_card_types: cardTypes
        }).then((res) => {
          if (res.code === 0) {
            this.isShow = false
            this.$emit('completed')
          }
          this.submitting = false
        }).catch(() => { this.submitting = false })
      })
    }
  }
}
</script>

<style scoped>
.item-title {
  display: block;
  font-weight: 600;
  margin: 8px 0 4px;
}
</style>
